export default __webpack_public_path__ + "static/media/product-06 (1).dab00d1d.jpg";